import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ThreeDPQuizContainer from "@/components/Quiz/3dpQuiz/ThreeDPQuizContainer";
import ThreeDPQuizResults from "@/components/Quiz/3dpQuiz/Results/ThreeDPQuizResults";
import ThreeDPPages from "@/components/Quiz/3dpQuiz/ThreeDPPages";
import ThreeDPEducation from "@/components/AthleteProfileEducation/threeDP/ThreeDPEducation";
import { ThreeDPQuizResultsType } from "@WahooFitness/cloud-client-types";
import { postClose, useHeaderContext } from "@WahooFitness/wahoo-offline-mfe";

function ThreeDPIndexPage() {
  const [searchParams] = useSearchParams();
  const closeOnBack = !!searchParams.get("from");
  const skipEducation = searchParams.has("skipEducation");
  const [page, setPage] = useState<ThreeDPPages>(
    skipEducation ? ThreeDPPages.quiz : ThreeDPPages.education
  );
  const [results, setResults] = useState<ThreeDPQuizResultsType | undefined>();
  const [error, setError] = useState<string>();

  const { navigateBack } = useHeaderContext();

  const handleQuizFirstStepBack = useCallback(() => {
    if (closeOnBack) {
      postClose("threedp");
    } else {
      navigateBack();
    }
  }, [closeOnBack, navigateBack]);

  switch (page) {
    case ThreeDPPages.quiz:
      return (
        <ThreeDPQuizContainer
          setResults={setResults}
          setError={setError}
          setPage={setPage}
          skipEducation={true}
          onFirstStepBack={handleQuizFirstStepBack}
        />
      );
    case ThreeDPPages.results:
      return (
        <ThreeDPQuizResults
          results={results}
          setPage={setPage}
          error={error}
          closeOnBack={closeOnBack}
        />
      );
    case ThreeDPPages.education:
    default:
      return <ThreeDPEducation setPage={setPage} closeOnBack={closeOnBack} isStandAlone={false} />;
  }
}

export default ThreeDPIndexPage;
